import { useMovementV2PageData } from 'src/app/pages/movementV2/pageContext';

type Result = ModelHookResult<{
	imgHref?: string | null;
}>;

export function useImageAttribution(): Result {
	const {
		data: {
			movement: { photo },
		},
	} = useMovementV2PageData();

	return {
		data: {
			imgHref: photo?.petitionMedium.url || null,
		},
	};
}
